import { render } from "./Tabs.vue?vue&type=template&id=59ca1650&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=59ca1650&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-59ca1650"

export default script